import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { FlexyFilterWrapperProps } from '../DatatableHeader';
import { FlexyMobilePopover } from '../FlexyMobilePopover';
import { useFilterKeyboardShortcuts } from '../../hooks/useFilterKeyboardShortcuts';

export const FlexyFilterExpandable: React.FunctionComponent<FlexyFilterWrapperProps> = function (
    props,
) {
    const { anchorEl, open, onCancel, onSubmit, children } = props;
    const theme = useTheme();
    const { palette } = theme;

    const handleClose = () => {
        onCancel();
    };

    const handleSubmit = () => {
        onSubmit();
    };

    const { submitLabel, cancelLabel } = useFilterKeyboardShortcuts(
        handleSubmit,
        handleClose,
        open,
    );

    const btnStyles = {
        padding: '8px 24px',
        borderRadius: '12px',
        fontFamily: 'Inter',
        fontSize: '15px',
        fontWeight: '500',
        lineHeight: '24px',
        textAlign: 'center',
        transition: 'all ease-in-out 300ms',
    };

    const containedBtnStyles = {
        ...btnStyles,
        color: palette.getContrastText(palette.primary.main),
        backgroundColor: palette.primary.main,
        '&:hover': {
            backgroundColor: palette.primary.light,
        },
    };

    const outlinedBtnStyles = {
        ...btnStyles,
        color: palette.primary.main,
        backgroundColor: 'transparent',
        border: `1px solid ${palette.primary.main}`,
        '&:hover': {
            backgroundColor:
                palette.mode === 'light'
                    ? `${palette.primary.main}14`
                    : `${palette.primary.main}24`,
            borderColor: palette.primary.light,
        },
    };

    const controls = (
        <Box
            sx={{
                width: '100%',
                padding: '10px 24px',
                display: 'flex',
                justifyContent: 'center',
                gap: '0 16px',
                boxShadow:
                    palette.mode === 'light'
                        ? '1px 1px 15px 0px rgba(0, 0, 0, 0.1)'
                        : '1px 1px 15px 0px rgba(0, 0, 0, 0.5)',
                marginTop: 'auto',
                backgroundColor:
                    palette.mode === 'light' ? palette.background.paper : palette.grey[900],
            }}
        >
            <Button
                variant="outlined"
                onClick={handleClose}
                sx={outlinedBtnStyles}
            >
                {cancelLabel || 'Fermer'}
            </Button>
            <Button
                variant="contained"
                onClick={handleSubmit}
                sx={containedBtnStyles}
            >
                {submitLabel}
            </Button>
        </Box>
    );

    return (
        <FlexyMobilePopover
            open={open}
            onClose={handleClose}
            anchorEl={anchorEl}
            controls={controls}
        >
            {children}
        </FlexyMobilePopover>
    );
};
